import {ru} from "./russian";
import {en} from "./english";


export const languages = {
    list:[
        {
            title:'Русский', alias: 'ru'
        },
        {
            title:'English', alias: 'en'
        },
    ],
    schema: { ru, en }
}
